"use strict";

var _classCallCheck = require("/home/abhishek/Documents/Macrometa/demos/tutorial-cryptotrading/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/abhishek/Documents/Macrometa/demos/tutorial-cryptotrading/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ApiKeys = /*#__PURE__*/function () {
  function ApiKeys(connection) {
    var keyid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var dbName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

    _classCallCheck(this, ApiKeys);

    this._connection = connection;
    this.keyid = keyid;
    this.dbName = dbName;
  }

  _createClass(ApiKeys, [{
    key: "validateApiKey",
    value: function validateApiKey(data) {
      return this._connection.request({
        method: "POST",
        path: "/_api/key/validate",
        body: data
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createApiKey",
    value: function createApiKey() {
      return this._connection.request({
        method: "POST",
        path: "/_api/key",
        body: {
          keyid: this.keyid
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getAvailableApiKeys",
    value: function getAvailableApiKeys() {
      return this._connection.request({
        method: "GET",
        path: "/_api/key"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getAvailableApiKey",
    value: function getAvailableApiKey() {
      return this._connection.request({
        method: "GET",
        path: "/_api/key/".concat(this.keyid)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "removeApiKey",
    value: function removeApiKey() {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/key/".concat(this.keyid)
      }, function (res) {
        return res.body;
      });
    } //---------------- database access level ----------------

  }, {
    key: "listAccessibleDatabases",
    value: function listAccessibleDatabases() {
      var full = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._connection.request({
        method: "GET",
        path: "/_api/key/".concat(this.keyid, "/database"),
        qs: {
          full: full
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getDatabaseAccessLevel",
    value: function getDatabaseAccessLevel() {
      return this._connection.request({
        method: "GET",
        path: "/_api/key/".concat(this.keyid, "/database/").concat(this.dbName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearDatabaseAccessLevel",
    value: function clearDatabaseAccessLevel() {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/key/".concat(this.keyid, "/database/").concat(this.dbName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "setDatabaseAccessLevel",
    value: function setDatabaseAccessLevel(permission) {
      return this._connection.request({
        method: "PUT",
        path: "/_api/key/".concat(this.keyid, "/database/").concat(this.dbName),
        body: {
          grant: permission
        }
      }, function (res) {
        return res.body;
      });
    } //---------------- Collection access level ----------------

  }, {
    key: "listAccessibleCollections",
    value: function listAccessibleCollections() {
      var full = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._connection.request({
        method: "GET",
        path: "/_api/key/".concat(this.keyid, "/database/").concat(this.dbName, "/collection"),
        qs: {
          full: full
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getCollectionAccessLevel",
    value: function getCollectionAccessLevel(collectionName) {
      return this._connection.request({
        method: "GET",
        path: "/_api/key/".concat(this.keyid, "/database/").concat(this.dbName, "/collection/").concat(collectionName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearCollectionAccessLevel",
    value: function clearCollectionAccessLevel(collectionName) {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/key/".concat(this.keyid, "/database/").concat(this.dbName, "/collection/").concat(collectionName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "setCollectionAccessLevel",
    value: function setCollectionAccessLevel(collectionName, permission) {
      return this._connection.request({
        method: "PUT",
        path: "/_api/key/".concat(this.keyid, "/database/").concat(this.dbName, "/collection/").concat(collectionName),
        body: {
          grant: permission
        }
      }, function (res) {
        return res.body;
      });
    } //---------------- Stream access level ----------------

  }, {
    key: "listAccessibleStreams",
    value: function listAccessibleStreams() {
      var full = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._connection.request({
        method: "GET",
        path: "/_api/key/".concat(this.keyid, "/database/").concat(this.dbName, "/stream"),
        qs: {
          full: full
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getStreamAccessLevel",
    value: function getStreamAccessLevel(streamName) {
      return this._connection.request({
        method: "GET",
        path: "/_api/key/".concat(this.keyid, "/database/").concat(this.dbName, "/stream/").concat(streamName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearStreamAccessLevel",
    value: function clearStreamAccessLevel(streamName) {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/key/".concat(this.keyid, "/database/").concat(this.dbName, "/stream/").concat(streamName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "setStreamAccessLevel",
    value: function setStreamAccessLevel(streamName, permission) {
      return this._connection.request({
        method: "PUT",
        path: "/_api/key/".concat(this.keyid, "/database/").concat(this.dbName, "/stream/").concat(streamName),
        body: {
          grant: permission
        }
      }, function (res) {
        return res.body;
      });
    } //---------------- Billing access level ----------------

  }, {
    key: "getBillingAccessLevel",
    value: function getBillingAccessLevel() {
      return this._connection.request({
        method: "GET",
        path: "/_api/key/".concat(this.keyid, "/billing")
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearBillingAccessLevel",
    value: function clearBillingAccessLevel() {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/key/".concat(this.keyid, "/billing")
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "setBillingAccessLevel",
    value: function setBillingAccessLevel(permission) {
      return this._connection.request({
        method: "PUT",
        path: "/_api/key/".concat(this.keyid, "/billing"),
        body: {
          grant: permission
        }
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return ApiKeys;
}();

exports.ApiKeys = ApiKeys;